module.exports = {
	"header": "Terminologie",
	"terms": {
		"appraisal": {
			"term": "Évaluation",
			"definition": "L'acte ou le processus d'estimer la valeur."
		},
		"absenteebidder": {
			"term": "Enchérisseur absent",
			"definition": "Une personne qui ne se présente pas à la vente aux enchères, mais qui fait valoir, à l'avance, une offre au prix maximun qu'elle est prête à payer pour un lot."
		},
		"asIs": {
			"term": "Tel quel",
			"definition": "Vente de l'article, sans garantie quant à l'état et/ou l'aptitude de l'article pour une utilisation particulière. Pour leur protection, les acheteurs sont seuls responsables d'examiner et de juger l'article. Aussi connu sous les noms \"Où il se trouve\" et \"Dans son état actuel\"."
		},
		"auction": {
			"term": "Encan",
			"definition": "Une méthode de vente des biens dans un forum public par appels d'offres ouverts et concurrentiels. Aussi connu comme \"enchères publiques\" ou \"vente aux enchères.\""
		},
		"auctionBlock": {
			"term": "Bloc d'encan",
			"definition": "Le podium ou la plateforme surélevée où l'encanteur se tient en menant la vente aux enchères."
		},
		"auctionPrice": {
			"term": "Prix de l'enchère",
			"definition": "Le montant obtenu pour un article vendu lors d'une vente aux enchères. Placer (un article) dans l'encan signifie \"vendre un article aux enchères.\""
		},
		"auctionSubjectToConfirmation": {
			"term": "Enchère sous réserve de confirmation",
			"definition": "(Voir \"Enchère avec réserve\")"
		},
		"auctionValue": {
			"term": "Valeur d'enchère",
			"definition": "Le montant qu'un article atteint via un appel d'offres aux enchères."
		},
		"auctionWithReserve": {
			"term": "Enchère avec réserve",
			"definition": "Une enchère dans laquelle le vendeur ou son agent se réserve le droit d'accepter ou de refuser toutes les offres. Un prix minimum acceptable peut ou non être divulgué et le vendeur se réserve le droit d'accepter ou de refuser toute offre."
		},
		"auctioneer": {
			"term": "Encanteur",
			"definition": "La personne que le vendeur engage afin de diriger, mener ou être responsable lors d'une vente aux enchères. Cette personne peut ou non appeler ou \"crier\" l'enchère."
		},
		"bankLetterOfCredit": {
			"term": "Lettre de crédit de la banque",
			"definition": "Une lettre de la banque certifiant qu'une personne nommée est digne d'un certain niveau de crédit. Souvent demandée aux acheteurs potentiels qui ne paient pas comptant."
		},
		"bid": {
			"term": "$t(auction::lot.bid)",
			"definition": "Une indication d'un acheteur potentiel d'un montant qu'il est prêt à débourser afin d'acheter un article en vente. Les offres sont habituellement par augmentation normalisée établie par l'encanteur."
		},
		"buyerPremium": {
			"term": "Prime",
			"definition": "Un pourcentage annoncé de l'offre la plus élevée ou un droit fixe ajouté à l'offre la plus élevée."
		},
		"catalog": {
			"term": "Catalogue",
			"definition": "Une publication décrivant les articles disponibles à la vente aux enchères, comprenant souvent des photos, des descriptions, des articles ainsi que les termes et conditions de la vente."
		},
		"collusion": {
			"term": "Complicité",
			"definition": "La pratique illégale selon laquelle deux ou plusieurs personnes conviennent de ne pas enchérir l'une contre l'autre afin de réduire la valeur de l'article ou lorsque l'encanteur accepte une offre fictive au nom du vendeur afin de manipuler ou d'augmenter le prix de l'article."
		},
		"conditionsOfSale": {
			"term": "Conditions de vente",
			"definition": "Les termes juridiques qui régissent la conduite d'une vente aux enchères, y compris les méthodes de paiement acceptables, les termes, les primes de l'acheteur, la possession, la réserve et d'autres facteurs limitants d'une vente aux enchères. Habituellement inclues dans les annonces publiées ou annoncées par l'encanteur avant le début de la vente aux enchères. Aussi connues comme ”Termes et Conditions”."
		},
		"dueDiligence": {
			"term": "Vérification préalable",
			"definition": "Le processus de collecte d'informations sur l'état et le statut juridique des actifs destinés à être vendus."
		},
		"hammerPrice": {
			"term": "Prix final",
			"definition": "Prix établi par le plus offrant et reconnu par l'encanteur."
		},
		"listingAgreement": {
			"term": "Convention d'inscription",
			"definition": "Un contrat entre l'encanteur et le vendeur qui autorise l'encanteur à procéder à la vente aux enchères et qui définit les termes de l'accord, ainsi que les droits et responsabilités de chaque partie."
		},
		"liveAuction": {
			"term": "Encan en temps réel",
			"definition": "Permet aux enchérisseurs hors du lieu de l'encan de placer des offres en même temps que la vente aux enchères se déroule dans les locaux de l'événement. Les acheteurs peuvent placer l'offre en utilisant leur ordinateur ou appareil mobile."
		},
		"lot": {
			"term": "Lot",
			"definition": "Item(s) vendu(s) à l'encan. Parfois, un groupe d'items est vendu en un seul lot. Normalement, un numéro unique est attribué à chaque lot."
		},
		"marketValue": {
			"term": "Valeur marchande",
			"definition": "Le prix qu'un article aurait obtenu sur le marché."
		},
		"minimumBidAuction": {
			"term": "Offre minimale",
			"definition": "Une enchère dans laquelle l'encanteur n'acceptera que des offres égales ou supérieures à un prix minimal, divulgué ou non."
		},
		"onLineAuction": {
			"term": "Encan en ligne",
			"definition": "Une vente aux enchères se déroulant uniquement sur le web et non dans un endroit avec une audience."
		},
		"onSiteAuction": {
			"term": "Encan sur les lieux",
			"definition": "Une vente aux enchères menée dans les locaux où se déroule l'encan."
		},
		"openingBid": {
			"term": "Offre d'ouverture",
			"definition": "La première offre faite par un acheteur potentiel aux enchères."
		},
		"preview": {
			"term": "Aperçu",
			"definition": "Date et heure où l'article est disponible pour l'inspection et les audits des acheteurs potentiels. Aussi connu comme \"Portes ouvertes\" ou \"Inspection\"."
		},
		"reserve": {
			"term": "Réserve",
			"definition": "Le prix minimum que le vendeur est prêt à accepter. Aussi connu comme \"prix de réserve\"."
		},
		"seller": {
			"term": "Vendeur",
			"definition": "La personne qui a la possession légale (propriété) de tout intérêt, des avantages ou des droits inhérents à la propriété réelle ou personnelle."
		},
		"subjectToConfirmation": {
			"term": "Sous réserve de confirmation",
			"definition": "Le montant final obtenu lors de l'enchère pourra être accepté ou refusé par le vendeur."
		},
		"termsAndConditions": {
			"term": "Termes et conditions",
			"definition": "Les règles de la vente aux enchères et certains aspects de la convention d'achat et de vente qui sont lus et/ou remis aux acheteurs potentiels avant une vente aux enchères."
		},
		"tieBids": {
			"term": "Offres concurrentes",
			"definition": "Lorsque deux ou plusieurs acheteurs offrent exactement le même montant en même temps. Ceci doit être résolu par l'encanteur."
		},
		"withdraw": {
			"term": "Retirer",
			"definition": "Échec pour atteindre le prix de réserve ou offre insuffisante."
		}
	}
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/locales/lib/fr/terminology.json5
// module id = 2012
// module chunks = 6